import { API_BASE_URL, deleteRequest, getRequest, postRequest } from "../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

export const fetchAssignableUsersApi = () =>
    getRequest({
        url: `${API_BASE_URL}/api/users`,
        token: getToken(),
        uid: getUid(),
    });

export const fetchAssignedUsersByEventApi = (eventId) =>
    getRequest({
        url: `${API_BASE_URL}/api/assignments/event/${eventId}`,
        token: getToken(),
        uid: getUid(),
    });

export const fetchAssignedUsersByModuleApi = (moduleId) =>
    getRequest({
        url: `${API_BASE_URL}/api/assignments/module/${moduleId}`,
        token: getToken(),
        uid: getUid(),
    });

export const bulkAssignUsersApi = (payload) =>
    postRequest({
        url: `${API_BASE_URL}/api/assignments/bulk`,
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const removeAssignmentApi = (assignmentId) =>
    deleteRequest({
        url: `${API_BASE_URL}/api/assignments/${assignmentId}`,
        token: getToken(),
        uid: getUid(),
    });
